import * as React from 'react';
import CloseButton from './CloseButton';
import { zIndex } from '../../constants';

interface SettingPopupProps {
  title: string;
  onClose: () => void;
}

// 今後ドラッグで動かすかもしれないからSFCじゃなくてPureComponent
class SettingPopup extends React.PureComponent<SettingPopupProps> {
  public render() {
    const backdropStyle: React.CSSProperties = {
      position: 'fixed',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: zIndex.settingPopup,
    };

    const dialogStyle: React.CSSProperties = {
      position: 'relative',
      border: '1px solid #575757',
      display: 'flex',
      flexDirection: 'column',
      margin: '48px',
      maxWidth: '600px',
      background: '#dedede',
      color: 'black',
    };

    const headerStyle: React.CSSProperties = {
      background: '#575757',
      paddingLeft: '1em',
      color: '#fff',
    };

    return (
      <aside style={backdropStyle} onClick={this.props.onClose}>
        <div style={dialogStyle} onClick={(ev) => { ev.stopPropagation(); }}>
          <header style={headerStyle}>
            <CloseButton onClick={this.props.onClose} />
            <h2>{this.props.title}</h2>
          </header>
          <div>
            {this.props.children}
          </div>
        </div>
      </aside>
    );
  }
}

export default SettingPopup;
